export default __webpack_public_path__ + "static/media/creme-caramel.ad7d296d.jpg";